import React, { Fragment, useEffect, useState } from "react";
import { useWalletList } from "../../../../custom-hooks/useWallet";
import { formatMoney } from "../../../../helpers/formatter";
import { MixPanel } from "../../../../shared/MixPanel/MixPanel";

const OfflineRequest = ({ properties, onCloseModal }) => {
  const {
    reference,
    handleSubmit,
    loading,
    handleReject,
    funder_id,
    currency,
    external_wallet_id,
    amountToCredit,
  } = properties;

  useEffect(() => {
    MixPanel.track(`Page View: OfflineRequest.tsx`, {
      page: "OfflineRequest.tsx",
    });
  }, []);

  const submitHandleApprove = (e) => {
    e.preventDefault();
    handleSubmit({ reference: reference, comment: comment });
  };
  const submitHandleReject = (e) => {
    e.preventDefault();
    handleReject({ reference: reference, comment: comment });
  };
  const [comment, setComment] = useState("");

  const {
    data: walletData,
    isLoading: walletDataIsLoading,
    error: walletDataError,
  } = useWalletList(funder_id, external_wallet_id);

  return (
    <div
      className="AuditTrailModal Modal__content"
      style={{ overflow: "hidden" }}
    >
      <div className="Modal__body">
        <Fragment>
          <h3 className="Modal__title p-b-1">Offline Request</h3>
          <hr />
          <form onSubmit={submitHandleApprove}>
            <div className="row">
              {walletDataError && (
                <p className="alert alert-danger col-md-6">
                  {walletDataError?.message ||
                    "Error fetching wallet balance.. Please reload"}
                </p>
              )}
              <div className="col-12 mb-1">
                <label>Wallet Balance</label>
                {walletDataIsLoading ? (
                  <p className="text-primary font-weight-bold">
                    Loading Wallet Details...
                  </p>
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    name="walletBalance"
                    defaultValue={formatMoney(
                      walletData?.[0]?.availableBalance || 0,
                      walletData?.[0]?.currency || "",
                    )}
                    readOnly
                  ></input>
                )}
              </div>
              <div className="col-12 mb-1">
                <label>Top-up Amount</label>
                <input
                  type="text"
                  className="form-control"
                  name="amount_to_credit"
                  defaultValue={formatMoney(
                    amountToCredit || 0,
                    currency || "",
                  )}
                  disabled
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Reference</label>
                <input
                  type="text"
                  className="form-control"
                  name="reference"
                  defaultValue={reference}
                  disabled
                ></input>
              </div>
              <div className="col-12 mb-1">
                <label>Comment</label>
                <input
                  type="text"
                  className="form-control"
                  name="comment"
                  defaultValue={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></input>
              </div>
              <div className="col-12 d-flex justify-content-end flex-wrap">
                <button
                  className="btn advancly-btn btn-sm transition-3d-hover mt-2 mr-2"
                  type="button"
                  disabled={loading || !comment || !reference}
                  onClick={submitHandleApprove}
                >
                  Approve
                </button>
                <button
                  className="btn advancly-dimred-btn btn-sm transition-3d-hover mt-2"
                  type="submit"
                  disabled={loading || !comment || !reference}
                  onClick={submitHandleReject}
                >
                  Reject
                </button>
              </div>
            </div>
          </form>
        </Fragment>
      </div>
    </div>
  );
};
export default OfflineRequest;
